import { inject, Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { environment } from '../../../environments/environment'
import { DISABLE_SPINNER_CONTEXT } from '../interceptors/loading-spinner.interceptor'

export interface City {
  ortsname: string
  alort: string
  gkz: string
  ortsteil: string
}

export interface Street {
  strasse: string
}

@Injectable({
  providedIn: 'root',
})
export class LocationService {
  private readonly http = inject(HttpClient)
  private readonly baseUrl = environment.apiUrl

  getCitiesByPostalCode(postalCode: string): Observable<City[]> {
    return this.http.get<City[]>(`${this.baseUrl}/validate`, {
      params: { type: 'city', plz: postalCode },
      context: DISABLE_SPINNER_CONTEXT,
    })
  }

  getStreetsByCity(postalCode: string, city: string): Observable<Street[]> {
    return this.http.get<Street[]>(`${this.baseUrl}/validate`, {
      params: { type: 'street', plz: postalCode, city },
      context: DISABLE_SPINNER_CONTEXT,
    })
  }
}
